export default "__VITE_ASSET__3600790b__"